import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import AdminDashboardPage from './AdminDashboardPage';
import DashboardPage from './DashboardPage';

/**
 * Routes the /dashboard URL to the right page based on the user's context.
 * Platform admins (admin role without an active company) see the global
 * stats dashboard. Everyone else (including admins after switching into
 * a company) sees the regular per-company dashboard.
 */
export default function DashboardRouter() {
  const { isAdmin, activeCompanyId } = useAuth();
  if (isAdmin && !activeCompanyId) {
    return <AdminDashboardPage />;
  }
  return <DashboardPage />;
}
